export const TestSuggestionsConfig = [
    {
        span: 4,
        height: "40px",
        classes: "marginTop-8",
    },

    {
        span: 6,
        height: "48px",
        classes: "marginTop-16",
    },
    {
        span: 6,
        height: "48px",
        classes: "marginTop-8",
    },
    {
        span: 6,
        height: "48px",
        classes: "marginTop-8",
    },
    {
        span: 6,
        height: "48px",
        classes: "marginTop-8",
    },
    {
        span: 6,
        height: "48px",
        classes: "marginTop-8",
    },
]
